import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { State } from '../services/work.state';

export const transferCall = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.transferCall !== undefined) {
        const newState = {
          ...state,
          ...{
            transferCall: state.system?.transferCall,
            system: {
              ...state.system,
              ...{
                transferCall: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
